import React from 'react';
import { ThemeProvider, useMediaQuery, Box } from '@mui/material';
import { LyraTheme } from '../components/theme/lyra/Theme';
import { FlexBoxColumn } from '../components/common/FlexBoxColumn';
import { FlexBoxRow} from '../components/common/FlexBoxRow';
import { AdGeneratorBackground } from '../components/common/adGenerator/Background';
import { WebsiteGraderNavBar } from '../components/common/websiteGrader/NavBar';
import { NavBar as CopyToolNavBar } from '../components/common/adGenerator/NavBar';
import { Footer } from '../components/common/adGenerator/Footer';
import { ErrorFlexBoxColumn } from '../components/common/websiteGrader/Error';
import { useLocation } from 'react-router-dom';

export const NotFoundLyra = () => {
  const location = useLocation();
  const state = location.state as { error?: string; source?: string } || {};
  const isMobile = useMediaQuery(LyraTheme.breakpoints.down('sm'));

  return (
    <ThemeProvider theme={{ ...LyraTheme }}>
      <FlexBoxColumn sx={{ alignItems: 'flex-start' }}>
        <AdGeneratorBackground>
          <FlexBoxRow
              sx={{
                paddingX: isMobile ? 2 : 5,
                paddingTop: isMobile ? 2 : 5,
                alignSelf: 'stretch',
                alignItems: 'flex-start',
                zIndex: 100,
              }}
          >
            {state.source === 'copy-tool' ? <CopyToolNavBar /> : <WebsiteGraderNavBar />}
          </FlexBoxRow>
          <FlexBoxColumn sx={{ justifyContent: 'center', width: '100%', gap: 3 }}>
            <Box sx={{ borderRadius: '12px', maxWidth: '600px', width: '100%', padding: isMobile ? 20 : 26 }}>
              <ErrorFlexBoxColumn
                  heading={state.error === 'missing_email' ? 'Email Address Required' : "Oops, this page doesn't exist."}
                  text={
                    state.error === 'missing_email'
                        ? 'An email address is required to use the Website Grader tool.'
                        : "The link you followed may be broken, or the page doesn't exist."
                  }
              />
            </Box>
          </FlexBoxColumn>
          <Footer />
        </AdGeneratorBackground>
      </FlexBoxColumn>
    </ThemeProvider>
  );
};
